import { axiosClient, API_BASE_URL } from "./axiosClient";

export const getCategories = async (): Promise<any> => {
  try {
    const categories = await axiosClient.get(`/products/categories/`);
    const resp = categories.data.data.map((item: any) => ({
      id: item.id,
      title: item.name,
      image: item.image_url,
      items: item.subcategories.map((item: any) => ({
        ...item,
        href: `/products/${item.id}`,
      })),
    }));
    return resp;
  } catch (e) {
    console.log(e);
    return [];
  }
};

export const getSubCategories = async (category_id: string) => {
  try {
    const response = await axiosClient.get(
      `/products/categories/${category_id}/subcategories/`
    );
    return response.data;
  } catch (e) {
    console.log(e);
    return e;
  }
};

export const getSingleProductDetail = async (id: string) => {
  try {
    const response = await axiosClient.get(
      `/products/products-details/${id}`
    );
    return response.data;
  } catch (e) {
    console.log(e);
    return e;
  }
};

export const getProductsDetails = async (product_id: string | undefined) => {
  let payload = {};
  if (product_id) {
    payload = { subcategory: product_id };
  }
  try {
    const response = await axiosClient.get(`/products/products-details/`, {
      params: payload,
    });
    return response.data;
  } catch (e) {
    console.log(e);
    return e;
  }
};

export const getBlogs = async (): Promise<any> => {
  try {
    const response = await axiosClient.get(`/blogs/blogs/`);
    const resp = response.data.map((item: any) => ({
      id: item.id,
      title: item.title,
      content: item.content,
      author: { displayName: item.author },
      date: item.published_date,
      href: `/blog-single/${item.id}`,
    }));
    return resp.sort(
      (a: any, b: any) =>
        new Date(b.date).getTime() - new Date(a.date).getTime()
    );
  } catch (e) {
    console.log(e);
    return e;
  }
};

export const getBlogsById = async (id: string) => {
  try {
    const response = await axiosClient.get(`/blogs/${id}/`);
    return response.data;
  } catch (e) {
    console.log(e);
    return e;
  }
};

export const getClients = async () => {
  try {
    const response = await axiosClient.get(`/portfolio/clients/`);
    return response.data;
  } catch (e) {
    console.log(e);
    return e;
  }
};

export const getProjects = async () => {
  try {
    const response = await axiosClient.get(`/portfolio/projects/`);
    return response.data;
  } catch (e) {
    console.log(e);
    return e;
  }
};

export const getProjectsById = async (id: string) => {
  try {
    const response = await axiosClient.get(`/portfolio/projects/${id}/`);
    return response.data;
  } catch (e) {
    console.log(e);
    return e;
  }
};

export const registerTicket = async (payload: {
  user_name: String;
  phone: String;
  email: String;
  message: String;
  company: String;
  company_email: String;
  company_phone: String;
  product: { sku: number; name: string };
}) => {
  try {
    const response = await axiosClient.post(
      `/contact/register-ticket/`,
      payload
    );
    return response.data;
  } catch (e) {
    console.log(e);
    return e;
  }
};

export const getColorandFinish = async (sku: string) => {
  try {
    const response = await axiosClient.get(
      `/products/get-product-filters`,
      { params: { product_id: sku } }
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getImages = async (
  product_id: string,
  color?: string,
  finish?: string
) => {
  let params: any = {};
  if (color) {
    params = { ...params, color };
  }
  if (finish) {
    params = { ...params, finish };
  }
  try {
    const response = await axiosClient.get(
      `/products/get-product-images/${product_id}/`,
      { params }
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getFeaturedProducts = async () => {
  try {
    const response = await axiosClient.get(
      `/products/get-featured-products`
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getPdfs = async () => {
  try {
    const response = await axiosClient.get(`/products/all-pdfs/`);
    return response.data;
  } catch (e) {
    console.log(e);
    return e;
  }
};

export { API_BASE_URL };
